import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

export const LabelTable = styled.div`
  color: #272729;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 29.5px; /* 92.188% */
  @media only screen and (max-width: 1366px) {
    font-size: 24px;
  }
  @media only screen and (max-width: 1024px) {
    color: #272729;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
    text-transform: capitalize;
  }
`;

export const LabelTableViewAll = styled.div`
  color: #818181;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const TextCellTable = styled.div`
  color: #000;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;
export const ContainerTableMobile = styled.div`
  border-radius: 20px;
  background: #fff;
  padding: 12px;
`;
export const ContainerTableMobileHome = styled.div`
  background: #fff;
`;

export const SlideBannerOuterContainer = styled.div`
  width: 100%;
  flex: 1;

  @media only screen and (min-width: 1024px) {
    width: calc(100% - 180px);
  }
`;

export const SlideBannerContainer = styled.div`
@media only screen and (max-width: 1024px) {
    position: relative;
    &.showOver {
      &::before {
        position: absolute;
        pointer-events: none;
        z-index: 10;
        width: 81px;
        height: 90px;
        right: -25px;
        bottom: 5px;
        background: linear-gradient(
          270deg,
          #f5f5f5 19.17%,
          rgba(245, 245, 245, 0) 83.33%
        );
      }
    }
  }
`;

export const SwiperWraper = styled(Swiper)`
  position: relative;
  &::after {
    content: "";
  }
`;

export const SwiperSlideWrapper = styled(SwiperSlide)`
  cursor: auto;
  @media only screen and (min-width: 1024px) {
    width: 370px !important;
  }

  @media only screen and (min-width: 1440px) {
    width: 460px !important;
  }

  @media only screen and (max-width: 1440px) {
    > div {
      height: 130px;
    }
  }

  @media only screen and (max-width: 1024px) {
    > div {
      height: 100px;
    }
  }
`

export const TextValueTable1 = styled.div`
  color: #272729;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TextValueTable2 = styled.div`
  color: #8c8d99;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TagComponent = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 38px;
  background: rgba(129, 129, 129, 0.1);

  color: #272729;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TagOptionFilter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 72px;
  background: #ffffff;
  border-radius: 24.3px;
  padding: 10px 20px;
  height: 40px;
  cursor: pointer;

  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px; /* 214.286% */
  text-transform: capitalize;
  &.checked {
    color: #ffffff;
    background-color: #000000;
  }
  &:hover {
    color: #ffffff;
    background-color: #000000;
  }
  @media (max-width: 640px) {
    color: #000000cc;
    font-size: 14px;
    line-height: 17px;
  }
`;

export const InfoTooltipIcon = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_19923_19060)">
      <path
        d="M2.19574 2.20102C3.65857 0.733173 5.42716 0 7.5 0C9.57284 0 11.3399 0.733173 12.8043 2.20102C14.2686 3.66887 15 5.4342 15 7.5C15 9.56581 14.2686 11.3326 12.8043 12.8005C11.3399 14.2683 9.57284 15 7.5 15C5.42716 15 3.65857 14.2668 2.19574 12.8005C0.732914 11.3341 0 9.56581 0 7.5C0 5.4342 0.731415 3.66737 2.19574 2.20102ZM3.26739 11.7608C4.43795 12.9342 5.84832 13.5216 7.5 13.5216C9.15168 13.5216 10.562 12.9342 11.7326 11.7608C12.9032 10.5874 13.4892 9.16767 13.4892 7.5C13.4892 5.83233 12.9032 4.41406 11.7326 3.23918C10.562 2.0643 9.15018 1.47837 7.5 1.47837C5.84982 1.47837 4.43795 2.06581 3.26739 3.23918C2.09682 4.41256 1.51079 5.83383 1.51079 7.5C1.51079 9.16617 2.09532 10.5874 3.26739 11.7608ZM6.7446 5.24639V3.73197H8.25539V5.24639H6.7446ZM6.7446 11.268V6.76082H8.25539V11.268H6.7446Z"
        fill="#101828"
      />
    </g>
    <defs>
      <clipPath id="clip0_19923_19060">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const InfoTooltipGradientIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <g clip-path="url(#clip0_13246_50702)">
  <path d="M2.34213 2.34776C3.90248 0.782051 5.78897 0 8 0C10.211 0 12.0959 0.782051 13.6579 2.34776C15.2198 3.91346 16 5.79647 16 8C16 10.2035 15.2198 12.0881 13.6579 13.6538C12.0959 15.2196 10.211 16 8 16C5.78897 16 3.90248 15.2179 2.34213 13.6538C0.781775 12.0897 0 10.2035 0 8C0 5.79647 0.780176 3.91186 2.34213 2.34776ZM3.48521 12.5449C4.73381 13.7965 6.23821 14.4231 8 14.4231C9.76179 14.4231 11.2662 13.7965 12.5148 12.5449C13.7634 11.2933 14.3885 9.77885 14.3885 8C14.3885 6.22115 13.7634 4.70833 12.5148 3.45513C11.2662 2.20192 9.76019 1.57692 8 1.57692C6.23981 1.57692 4.73381 2.20353 3.48521 3.45513C2.23661 4.70673 1.61151 6.22276 1.61151 8C1.61151 9.77724 2.23501 11.2933 3.48521 12.5449ZM7.19424 5.59615V3.98077H8.80575V5.59615H7.19424ZM7.19424 12.0192V7.21154H8.80575V12.0192H7.19424Z" fill="url(#paint0_linear_13246_50702)"/>
  </g>
  <defs>
  <linearGradient id="paint0_linear_13246_50702" x1="0" y1="8.00055" x2="16.0008" y2="8.00055" gradientUnits="userSpaceOnUse">
  <stop stop-color="#000"/>
  <stop offset="1" stop-color="#000"/>
  </linearGradient>
  <clipPath id="clip0_13246_50702">
  <rect width="16" height="16" fill="white"/>
  </clipPath>
  </defs>
  </svg>

);

export const UlCustom = styled.ul`
  & a {
    color: #1b559f;
    text-decoration: underline;
  }
`;

export const EqualIconSmall =()=> (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_21310_17527)">
      <path
        d="M7.56049 2.53994C6.72017 2.53238 5.89378 2.34231 5.1481 1.98488C3.94605 1.39028 2.50104 1.39028 1.299 1.98488L0.811157 1.095C2.31943 0.355377 4.12766 0.355377 5.63594 1.095C6.83798 1.6896 8.283 1.6896 9.48504 1.095L9.97288 1.98488C9.2272 2.34231 8.4008 2.53238 7.56049 2.53994Z"
        fill="#8C8D99"
      />
      <path
        d="M7.56049 6.53994C6.72017 6.53238 5.89378 6.34231 5.1481 5.98488C3.94605 5.39028 2.50104 5.39028 1.299 5.98488L0.811157 5.095C2.31943 4.35538 4.12766 4.35538 5.63594 5.095C6.83798 5.6896 8.283 5.6896 9.48504 5.095L9.97288 5.98488C9.2272 6.34231 8.4008 6.53238 7.56049 6.53994Z"
        fill="#8C8D99"
      />
    </g>
    <defs>
      <clipPath id="clip0_21310_17527">
        <rect
          width="9.216"
          height="6"
          fill="white"
          transform="translate(0.784058 0.540039)"
        />
      </clipPath>
    </defs>
  </svg>
);
